type ZendeskRoute = {
  zendeskFeatureFlag?: string;
  zendeskWidget?: boolean;
};

type FeatureFlags = Record<string, boolean | undefined>;

export const shouldShowZendesk = (route?: ZendeskRoute, featureFlags?: FeatureFlags) => {
  if (!route?.zendeskWidget) {
    return false;
  }

  if (route.zendeskFeatureFlag) {
    return !!featureFlags?.[route.zendeskFeatureFlag];
  }

  return true;
};
